export default {
  storeStatementList(state, statements) {
    state.statements = statements;
  },
  storeStatement(state,statement) {
    state.statement = statement
  },
  storeCreatedStatement(state,createdStatement) {
    state.statements << createdStatement
  },
  storeUpdatedStatement(state,updatedStatement) {
    state.statement = updatedStatement
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/statements/mutations.js